import initialState from "./initialState";
import { 
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE
 } from "../constants/actionTypes";

export default function usersReducer(state = initialState.users, action) {
  switch (action.type) {
    case GET_USERS:
    case GET_USERS_FAILURE:
      return [];

    case GET_USERS_SUCCESS:
      return action.payload;

    default:
      return state;
  }
}
